<template>
    <div>
        <div v-show="tabs.length > 1">
            <ul class="nav nav-tabs">
                <li v-for="tab in tabs" :class="{ active: tab.isActive }">
                    <a @click="selectTab(tab)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>

        <div :class="tabs.length > 1 ? 'tab-content' : ''">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Tabs",
    data() {
        return { tabs: [] };
    },
    created() {
        this.tabs = this.$children;
    },
    methods: {
        setSelected(selectedTab) {
            this.tabs.forEach((tab) => {
                tab.isActive = tab.name == selectedTab.name;
            });
        },
        selectTab(selectedTab) {
            var self = this;
            if (_.isFunction(selectedTab.beforeSelect)) {
                selectedTab.beforeSelect().then(function (res) {
                    if (res) {
                        self.setSelected(selectedTab);
                    }
                });
            } else {
                self.setSelected(selectedTab);
            }
        },
    },
};
</script>
